import React from 'react';
import PropTypes from 'prop-types';

const Tab = ({ active, eventKey, children }) => {
    return active === eventKey && <>{children}</>;
};

Tab.propTypes = {
    active: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    eventKey: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    children: PropTypes.node,
};

export default Tab;
